import { Badge, Box, Card, Text, TextField,InlineStack, Button, OptionList, Popover, BlockStack, Thumbnail } from '@shopify/polaris';
import React, { useState } from 'react';
import SwitchButton from '../../../OrderFulfillment/components/SwitchButton';

const BasicPriceBox = ({pageData,setPageData})=> {
    const options = [
        {label: <span style={{textAlign:'center',width:'36px',display:'inline-block',fontSize:'18px',fontWeight:650}}>+</span>, value: 2},
        {label: <span style={{textAlign:'center',width:'36px',display:'inline-block',fontSize:'18px',fontWeight:650}}>×</span>, value: 1},
      ];
    const [formatOpen,setFormatOpen] = useState(0);
    // 修改价格系数和对比价
    const onChangePrice = (type,val)=>{
        let value = val
        if (type === 'price_mark' || type === "compared_price_mark") {
            setPageData(prev=>({
                ...prev,
                general_rule:{
                    ...prev.general_rule,
                    [type]:value
                }
            }))
            setFormatOpen(0)
            return;
        }
        if (val.length > 10 ) return; 
         // 过滤非法字符并处理格式
        value = value.replace(/[^0-9.]/g, '');
        value = value.replace(/\.{2,}/g, '.'); // 防止多个小数点
        const parts = value.split('.');
        
        // 处理小数部分
        if (parts.length > 1) {
        value = parts[0] + '.' + parts[1].slice(0, 2);
        }
        // 防止以0开头的整数（可选）
        if (parts[0]?.length > 1 && parts[0][0] === '0') {
        value = parts[0].substr(1) + (parts[1] ? `.${parts[1]}` : '');
        }
        setPageData(prev=>({
            ...prev,
            general_rule:{
                ...prev.general_rule,
                [type]:value
            }
        }))
    }
    // 失焦重置
    const onChangePriceBlur = (type,val)=>{
        let value = val;
    
    // 处理边界情况
    if (value === '' || value === '.') {
        setPageData(prev=>({
            ...prev,
            general_rule:{
                ...prev.general_rule,
                [type]:1
            }
        }))
      return;
    }

    // 补充前导零
    if (value.startsWith('.')) {
      value = '0' + value;
    }
    const numericValue = parseFloat(value);
    // 数值验证
    if (isNaN(numericValue) || numericValue <= 0) {
        setPageData(prev=>({
            ...prev,
            general_rule:{
                ...prev.general_rule,
                [type]:1
            }
        }))
    } else {
      // 格式化显示
      let formatted = numericValue.toFixed(2)
        .replace(/\.00$/, '')
        .replace(/(\.\d)0$/, '$1');
      setPageData(prev=>({
        ...prev,
        general_rule:{
            ...prev.general_rule,
            [type]:formatted
        }
    }))
    }
    }
    const handleCompareSwitch = (type)=>{
        if (type === 'compared_price_on') {
            setPageData(prev=>({
                ...prev,
                general_rule:{
                    ...prev.general_rule,
                    compared_price_on:prev.general_rule.compared_price_on ? 0 : 1
                }
            }))
        }
    }

    // 示例价格
    const handleExamplePrice = (mark,factor)=>{
        let price = 12.8;
        if (mark === 2) {
            price = (price + Number(factor));
        }else {
            price = (price * Number(factor));
        }
        return price.toFixed(2);
    }
    
    return (
        <Box>
            <BlockStack gap={400}>
            <Card padding={0} roundedAbove="xs">
                <Box style={{background: "rgba(247, 247, 247, 1)",padding:'16px 12px'}}>
                    <BlockStack gap={400}>
                    <Box>
                        <Text variant="headingSm" as="h6">
                        Pricing Rule
                        </Text>
                    </Box>
                    <Box>
                        <InlineStack gap="200" blockAlign='center'>
                            <span>Selling price =</span>
                            <span className='price_coefficient_badge'><Badge tone='info'> <span className='color1_price'>Product cost</span></Badge></span>
                            <Box className="price_coefficient_operator">
                           <Popover
                            active={formatOpen === 1}
                            activator={ <Button disclosure="select" onClick={()=>{setFormatOpen(formatOpen === 1 ? 0 : 1)}}>
                                {pageData?.general_rule?.price_mark === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                            </Button>}
                            autofocusTarget="first-node"
                            onClose={()=>{setFormatOpen(0)}}
                        >
                            <Box style={{width:'80px',textAlign:'center'}}>
                            <OptionList
                            onChange={(val)=>{
                                onChangePrice('price_mark',val[0])
                            }}
                            selected={[pageData?.general_rule?.price_mark]}
                            options={options}
                            />
                            </Box>
                        </Popover>
                            </Box>
                           
                            <Box className="price_coefficient_input">
                                <TextField
                                value={pageData?.general_rule?.price_factor}
                                onChange={(val)=>{
                                    onChangePrice('price_factor',val)
                                }}
                                onBlur={(e)=>{
                                    onChangePriceBlur('price_factor',e.target.value)
                                }}
                                />
                            </Box>
                        </InlineStack>
                    </Box>
                    <Box>
                        <InlineStack gap="200" blockAlign='center'>
                            <span>Original price  =</span>
                            <span className='price_coefficient_badge'><Badge tone='info'><span className='color1_price'>Product cost</span></Badge></span>
                            <Box className="price_coefficient_operator">
                           <Popover
                            active={formatOpen === 2}
                            activator={ <Button disclosure="select" disabled={pageData?.general_rule?.compared_price_on === 0} onClick={()=>{setFormatOpen(formatOpen === 2 ? 0 : 2)}}>
                                {pageData?.general_rule?.compared_price_mark === 2 ? <span style={{fontWeight:'650',fontSize:'18px'}}>+</span> : <span style={{fontWeight:'650',fontSize:'18px'}}>×</span>}
                            </Button>}
                            autofocusTarget="first-node"
                            onClose={()=>{setFormatOpen(formatOpen === 2 ? 0 : 2)}}
                        >
                            <Box style={{width:'80px',textAlign:'center'}}>
                            <OptionList
                            onChange={(val)=>{
                                onChangePrice('compared_price_mark',val[0])
                            }}
                            selected={[pageData?.general_rule?.compared_price_mark]}
                            options={options}
                            />
                            </Box>
                        </Popover>
                            </Box>
                           
                            <Box className="price_coefficient_input">
                                <TextField
                                disabled={pageData?.general_rule?.compared_price_on === 0}
                                value={pageData?.general_rule?.compared_price_factor}
                                onChange={(val)=>{
                                    onChangePrice('compared_price_factor',val)
                                }}
                                onBlur={(e)=>{
                                    onChangePriceBlur('compared_price_factor',e.target.value)
                                }}
                                />
                            </Box>
                            <Box>
                            <SwitchButton open={pageData?.general_rule?.compared_price_on} handleSwitch={()=>{handleCompareSwitch('compared_price_on')}}/>
                            </Box>
                        </InlineStack>
                    </Box>
                    </BlockStack>
                </Box>
            </Card>
            <Card roundedAbove="xs">
                <BlockStack gap={200}>
                <Box>
                <Badge>
                  <InlineStack blockAlign='center' gap={100}>
                    <span style={{display:"inline-block",width:'8px',height:'8px',background:'rgb(4, 123, 93)',borderRadius:'2px'}}></span>
                    Demo
                    </InlineStack>
                </Badge>
                </Box>
                <Box>
                Product cost:  $ 12.8
                </Box>
                <Box>
                    <Card roundedAbove="xs">
                        <InlineStack gap={200}  wrap={false}>
                            <Box style={{width:'48px'}}>
                            <Thumbnail
                            source="/order_fulfillment/test_price_image.png"
                            alt="Black choker necklace"
                            />
                            </Box>
                            <Box>
                                <Box className="price-box-name">
                                Stylish Personality Alphabet Printed Bouquet Pocket
                                </Box>
                                <Box className="price-box-mobile">
                                    <InlineStack>
                                        <Box>
                                            <Text variant="headingSm" as="h6">
                                            Selling price: $ {handleExamplePrice(pageData?.general_rule?.price_mark,pageData?.general_rule?.price_factor)}
                                            </Text>
                                        </Box>
                                        {pageData?.general_rule?.compared_price_on === 0 ? '' : <Box className="price_coefficient_original_price">
                                            <Text variant="headingSm" as="h6">
                                            Original price: $ {handleExamplePrice(pageData?.general_rule?.compared_price_mark,pageData?.general_rule?.compared_price_factor)}
                                            </Text>
                                        </Box>}
                                    </InlineStack>
                                </Box>
                            </Box>
                        </InlineStack>
                        <Box className="price-box-pc">
                        <InlineStack>
                        <Box>
                            <Text variant="headingSm" as="h6">
                            Selling price: $ {handleExamplePrice(pageData?.general_rule?.price_mark,pageData?.general_rule?.price_factor)}
                            </Text>
                        </Box>
                        {pageData?.general_rule?.compared_price_on === 0 ? '' : <Box className="price_coefficient_original_price">
                            <Text variant="headingSm" as="h6">
                            Original price: $ {handleExamplePrice(pageData?.general_rule?.compared_price_mark,pageData?.general_rule?.compared_price_factor)}
                            </Text>
                        </Box>}
                    </InlineStack>
                    </Box>
                    </Card>
                </Box>
                </BlockStack>
            </Card>
            </BlockStack>
        </Box>
    );
}

export default BasicPriceBox;
